<template>
  <div class="bg-input">
    <label class="bg-input__label" v-if="label" :for="name">{{ label }}</label>
    <div class="bg-input__input-container">
      <textarea
        v-if="tag === 'textarea'"
        :class="
          `bg-input__input bg-input__input--textarea ${error &&
            'bg-input__input--error'} ${disabled &&
            'bg-input__input--disabled'}`
        "
        v-bind="{ name, id: name, placeholder, disabled }"
        v-model="input"
        @blur="$emit('blur', input)"
        ref="input"
        :rows="rows"
      />
      <input
        v-else
        :class="
          `bg-input__input ${error && 'bg-input__input--error'} ${disabled &&
            'bg-input__input--disabled'} ${valid && 'bg-input__input--valid'}`
        "
        v-bind="{ name, id: name, placeholder, type, disabled }"
        v-model="input"
        @blur="$emit('blur', input)"
        ref="input"
      />
      <transition name="bounce">
        <bg-icon v-if="valid" class="bg-input__valid-check" name="check" />
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";

export default {
  name: "BgInput",
  components: {
    BgIcon
  },
  props: {
    placeholder: String,
    tag: {
      type: String,
      default: "input"
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    rows: {
      type: Number,
      default: 1
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      default: false
    },
    error: {
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    width: {}
  },
  watch: {
    input: function() {
      this.$emit("input", this.input);
      this.$emit("change", this.input);
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  }
};
</script>
